<template>
  <div data-v-1b2f781e="" data-v-e5781868="" class="withdraw mainContent top50">
    <div data-v-1b2f781e="" class="content">
      <div data-v-1b2f781e="" class="title">
        <a href="javascript:void(0);" @click="$router.go(-1)"
          ><svg data-v-338e1447="" data-v-1b2f781e="" aria-hidden="true" class="svg-icon undo">
            <use data-v-338e1447="" xlink:href="#icon-undo"></use></svg
          >取款</a
        >
      </div>
      <div data-v-1b2f781e="" class="box">
        <div data-v-1b2f781e="" class="sidebar">
          <div data-v-1b2f781e="" class="group">
            <p data-v-1b2f781e="">取款方式</p>
            <div data-v-1b2f781e="" :class="type == 0 ? 'nav active' : 'nav '" @click="changType(0)">
              人民币<svg data-v-338e1447="" data-v-1b2f781e="" aria-hidden="true" class="svg-icon arrowRight">
                <use data-v-338e1447="" xlink:href="#icon-arrowRight"></use>
              </svg>
            </div>
            <div data-v-1b2f781e="" :class="type == 1 ? 'nav active' : 'nav '" @click="changType(1)">
              虚拟币取款
              <svg data-v-338e1447="" data-v-1b2f781e="" aria-hidden="true" class="svg-icon arrowRight">
                <use data-v-338e1447="" xlink:href="#icon-arrowRight"></use>
              </svg>
            </div>
          </div>
        </div>
        <div data-v-51c5dcd0="" data-v-1b2f781e="" class="right quickWithdraw" v-if="type == 0">
          <h3 data-v-51c5dcd0="">人民币</h3>

          <div data-v-51c5dcd0="" class="block">
            <div data-v-51c5dcd0="" class="c">
              <form data-v-51c5dcd0="">
                <div data-v-51c5dcd0="" class="formGroup">
                  <label data-v-51c5dcd0="">提现到</label>
                  <div data-v-51c5dcd0="" class="bankList">
                    <div data-v-51c5dcd0="" :class="bankId == item.id ? 'item active' : 'item'" @click="changBankId(item.id)" v-for="(item, index) in cardLis" :key="index">
                      <div data-v-51c5dcd0="" class="title">
                        <img data-v-338e1447="" data-v-51c5dcd0="" aria-hidden="true" class="svg-icon sponsor1" style="width: 15px; height: 15px; margin-right: 6px" :src="item.ico" alt="" />

                        {{ item.bank }}
                      </div>
                      <div data-v-51c5dcd0="" class="txt">
                        <span data-v-51c5dcd0="">{{ item.bank_owner }}</span>
                      </div>
                      <div data-v-51c5dcd0="" class="txt">
                        <span data-v-51c5dcd0="">{{ item.bank_no }}</span>
                      </div>
                    </div>

                    <div data-v-51c5dcd0="" class="item add" @click="$parent.goNav('/myWallet')" v-if="cardLis.length < 5">
                      <div data-v-51c5dcd0="" class="txt">
                        <a href="javascript:void(0);"
                          ><svg data-v-338e1447="" data-v-51c5dcd0="" aria-hidden="true" class="svg-icon iconplus">
                            <use data-v-338e1447="" xlink:href="#icon-iconplus"></use>
                          </svg>
                          前往添加银行卡
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div data-v-51c5dcd0="">
                  <div data-v-51c5dcd0="" class="formGroup">
                    <label data-v-51c5dcd0="">提现金额</label>
                    <div data-v-51c5dcd0="" class="inputGroup">
                      <input data-v-51c5dcd0="" type="text" placeholder="请输入提现金额" v-model="amount" autocomplete="new-password" />
                      <span data-v-51c5dcd0="" class="currency"></span>
                    </div>
                    <div data-v-51c5dcd0="" class="note"></div>
                  </div>
                  <div data-v-51c5dcd0="" class="formGroup">
                    <label data-v-51c5dcd0="">资金密码</label>
                    <div data-v-51c5dcd0="" class="inputGroup">
                      <input data-v-51c5dcd0="" type="password" placeholder="请输入资金密码" v-model="password" autocomplete="new-password" />
                      <span data-v-51c5dcd0="" class="currency"></span>
                    </div>
                  </div>
                  <a data-v-51c5dcd0="" class="button" @click="withdraw">确认提交</a>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div data-v-1b2f781e="" class="right questions" v-if="type == 1">
          <h3 data-v-1b2f781e="">虚拟币取款</h3>
          <div data-v-51c5dcd0="" class="block">
            <div data-v-51c5dcd0="" class="c">
              <form data-v-51c5dcd0="">
                <div data-v-51c5dcd0="" class="formGroup">
                  <label data-v-51c5dcd0="">提现到</label>
                  <div data-v-51c5dcd0="" class="bankList">
                    <div data-v-51c5dcd0="" :class="bankId == item.id ? 'item active' : 'item'" @click="changBankId(item.id)" v-for="(item, index) in usdssLis" :key="index">
                      <div data-v-51c5dcd0="" class="title">
                        <span style="width: 5px; height: 15px; margin-right: 6px; display: inline-bolck"></span>

                        {{ item.bank_owner }}
                      </div>
                      <div data-v-51c5dcd0="" class="txt">
                        <span data-v-51c5dcd0="" style="word-break: break-all; width: 100%; overflow: auto; margin-top: 6px">{{ item.bank_no }}</span>
                      </div>
                    </div>

                    <div data-v-51c5dcd0="" class="item add" @click="$parent.goNav('/myWallet')" v-if="usdssLis.length < 5">
                      <div data-v-51c5dcd0="" class="txt">
                        <a href="javascript:void(0);"
                          ><svg data-v-338e1447="" data-v-51c5dcd0="" aria-hidden="true" class="svg-icon iconplus">
                            <use data-v-338e1447="" xlink:href="#icon-iconplus"></use>
                          </svg>
                          新增USDT地址
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div data-v-51c5dcd0="">
                  <div data-v-51c5dcd0="" class="formGroup">
                    <label data-v-51c5dcd0="">提现金额</label>
                    <div data-v-51c5dcd0="" class="inputGroup">
                      <input data-v-51c5dcd0="" type="text" placeholder="请输入提现金额" v-model="amount" autocomplete="new-password" />
                      <span data-v-51c5dcd0="" class="currency"></span>
                    </div>
                    <div data-v-51c5dcd0="" class="note"></div>
                  </div>
                  <div data-v-51c5dcd0="" class="formGroup">
                    <label data-v-51c5dcd0="">资金密码</label>
                    <div data-v-51c5dcd0="" class="inputGroup">
                      <input data-v-51c5dcd0="" type="password" placeholder="请输入资金密码" v-model="password" autocomplete="new-password" />
                      <span data-v-51c5dcd0="" class="currency"></span>
                    </div>
                  </div>
                  <div data-v-51c5dcd0="" class="formGroup" v-if="chanmeyXi" >
                    <label data-v-51c5dcd0="">每笔手续费</label>
                    <div data-v-51c5dcd0="" style="line-height: 0.4rem" class="inputGroup">
                      {{ chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee : $store.state.userInfo.withdrawfeeusdttrc }}USDT
                    </div>
                  </div>
                     <div data-v-51c5dcd0="" class="formGroup" >
                    <label data-v-51c5dcd0="">USDT换算</label>
                    <div data-v-51c5dcd0="" style="line-height: 0.4rem" class="inputGroup">
                      {{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 : '0.00' }}
                      USDT &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;参考汇率：{{ $store.state.userInfo.withdrawusdtrate }}
                    </div>
                  </div>
                     <div data-v-51c5dcd0="" class="formGroup" >
                    <label data-v-51c5dcd0="">实际到账</label>
                    <div data-v-51c5dcd0="" style="line-height: 0.4rem" class="inputGroup">
                      {{ amount ? Math.floor((amount / $store.state.userInfo.withdrawusdtrate) * 100) / 100 - (chanmeyXi == 'ERC20' ? $store.state.userInfo.withdrawcashfee * 1 : $store.state.userInfo.withdrawfeeusdttrc * 1) : '0.00' }} USDT
                    </div>
                  </div>

                  <a data-v-51c5dcd0="" class="button" @click="withdraw1">确认提交</a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div data-v-226bc1a2="" data-v-1eba2a24="" v-if="showUsdt" class="mask addBankCardDialog backdrop">
        <div data-v-226bc1a2="" class="popup pop1">
          <span data-v-226bc1a2="" class="close" @click="openUsdt"></span>
          <div data-v-226bc1a2="" class="titlebar">添加USDT地址</div>
          <div data-v-226bc1a2="" class="form">
            <div data-v-226bc1a2="" class="item">
              <div data-v-226bc1a2="" class="box dropbank" @click="openBank">
                <div data-v-226bc1a2="" class="icon">
                  <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconCard1">
                    <use data-v-338e1447="" xlink:href="#icon-iconCard1"></use>
                  </svg>
                </div>
                <input data-v-226bc1a2="" v-model="meyXi" disabled placeholder="请选择协议" class="form-input form-input2" />
                <div data-v-226bc1a2="" class="icon">
                  <img
                    data-v-226bc1a2=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxMWZmNzA2NS04OWJmLTRjYjItODdmZS03ZTQ4YmFlOTBkNDAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTRBRTM0RTNGMUFDMTFFNkFGQzhGNjUxQ0Y5Qjc5RTEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTRBRTM0RTJGMUFDMTFFNkFGQzhGNjUxQ0Y5Qjc5RTEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpiOWJiYTMwNi02NzY2LTRjZTgtOTAwOS03Zjc2OTM0NTEyNTQiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDo4NWViOTEwZi0yM2RiLTExN2EtOGQ5My1jZTY0N2FjZDJlZDkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5GQ7trAAAAaklEQVR42mJsamqaw8DAkMxAGMxlAhLZQHyGgEKQfDZI8U8gDgbi1zgUvobK/2SCCjwC4kgg/oumEMSPhsozMCFJ7AXiKjTFIP5uGIcJTbIbiNdC2WuhfDhgQVP8H4iTgJgZSv9HlgQIMAAvsRYhT0B6LgAAAABJRU5ErkJggg=="
                    alt=""
                    class="icon-arrow"
                  />
                </div>
                <div data-v-226bc1a2="" class="dropDown" v-if="bankShow">
                  <div data-v-226bc1a2="" class="dropDownList">
                    <ul data-v-226bc1a2="" class="bankList">
                      <li data-v-226bc1a2="" @click="changmeyXi('ERC20')">
                        <span>ERC20</span>
                      </li>
                      <li data-v-226bc1a2="" @click="changmeyXi('TRC20')">
                        <span>TRC20</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div data-v-226bc1a2="" class="errorTxt"></div>
            </div>

            <div data-v-226bc1a2="" class="item">
              <div data-v-226bc1a2="" class="box">
                <div data-v-226bc1a2="" class="icon">
                  <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconPin">
                    <use data-v-338e1447="" xlink:href="#icon-iconPin"></use>
                  </svg>
                </div>
                <input data-v-226bc1a2="" placeholder="请输入USDT地址" v-model="usdss" class="form-input form-input2" />
              </div>
              <div data-v-226bc1a2="" class="errorTxt" style="display: none"></div>
            </div>
            <div data-v-226bc1a2="" class="item">
              <div data-v-226bc1a2="" class="box">
                <div data-v-226bc1a2="" class="icon">
                  <svg data-v-338e1447="" data-v-226bc1a2="" aria-hidden="true" class="svg-icon iconPin">
                    <use data-v-93652822="" data-v-338e1447="" xlink:href="#icon-iconPopPassword"></use>
                  </svg>
                </div>
                <input data-v-226bc1a2="" type="password" placeholder="请输入支付密码" v-model="pay_pass" class="form-input form-input2" />
              </div>
              <div data-v-226bc1a2="" class="errorTxt" style="display: none"></div>
            </div>
          </div>
          <div data-v-226bc1a2="" class="button"><span data-v-226bc1a2="" @click="bindUsdss" class="btn">确定</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'withdraw',
  data() {
    return {
      type: 0,
      cardLis: [],
      usdssLis: [],
      baseURL: '',
      bankId: '',
      amount: null,
      password: null,
      showUsdt: false,
      pay_pass: null,
      usdss: null,
      meyXi: 'ERC20', //qian
      chanmeyXi: null,
      bankShow: false,
    };
  },
  created() {
    let that = this;
    that.getcard();
    that.getUsdssList();
    that.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  methods: {
    openBank() {
      this.bankShow = !this.bankShow;
    },
    changmeyXi(val) {
      this.meyXi = val;
    },
    bindUsdss() {
      let that = this;
      let usdss = that.usdss;
      let meyXi = that.meyXi;

      if (usdss == null || usdss == '') {
        that.$parent.showTost(0, '请输入USDT地址');
        return;
      }
      if (!meyXi) {
        that.$parent.showTost(0, '请选择钱包协议');
        return;
      }
      if (!that.pay_pass) {
        that.$parent.showTost(0, '请输入支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/bindcard', { bank: 'USDT', bank_no: usdss, bank_owner: meyXi, pay_pass: that.pay_pass })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '添加成功！');
            that.getUsdssList();
            that.openUsdt();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    openUsdt() {
      this.showUsdt = !this.showUsdt;
      this.pay_pass = null;
      this.usdss = null;
    },
    getUsdssList() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
      });
    },
    withdraw() {
      let that = this;
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;

      if (amount < 100) {
        that.$parent.showTost(0, '单笔取款不能低于100元');
        return;
      }
      if (!bank) {
        that.$parent.showTost(0, '请选择您要提现到的银行卡');
        return;
      }
      if (!password) {
        that.$parent.showTost(0, '请输入您的支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '提交成功，等待后台审核');

            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/fundingRecords' });
            }, 1500);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    withdraw1() {

      let that = this;

      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      if (!bank) {
        that.$parent.showTost(0, '请选择USDT地址');
        return;
      }
      if (amount < 100) {
        that.$parent.showTost(0, '单笔取款不能低于100元');
        return;
      }

      if (!password) {
        that.$parent.showTost(0, '请输入您的支付密码');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.$parent.showTost(1, '提交成功，等待后台审核');
            that.chanmeyXi = null;
            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/fundingRecords' });
            }, 1500);
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changBankId(id) {
      let that = this;
      that.bankId = id;
      let chanmeyXi = null;

      if (that.type == 1) {
        that.usdssLis.forEach(el => {
          if (el.id == id) {
            chanmeyXi = el.bank_owner;
            return;
          }
        });
      }
      that.chanmeyXi = chanmeyXi;
    },
    getcard() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getcard', { type: 1 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    changType(val) {
      let that = this;
      if (that.type == val) {
        return;
      }
      that.type = val;
      that.amount = null;
      that.password = null;
      that.bankId = null;
      that.chanmeyXi = null;
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      // console.log(u, i, o);
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-1b8d3494.7ba596ce.css';
@import '../../../static/css/chunk-1c04a8aa.d5fb21bf.css';
@import '../../../static/css/chunk-06254e6a.f0cc50a1.css';
@import '../../../static/css/chunk-645a6edf.25ca78d5.css';
@import '../../../static/css/chunk-29b951e4.0bcca33f.css';
@import '../../../static/css/chunk-06254e6a.f0cc50a1.css';
@import '../../../static/css/chunk-645a6edf.25ca78d5.css';
@import '../../../static/css/chunk-4344ad92.cf88b5c7.css';
@import '../../../static/css/chunk-970915c0.1e5ddf77.css';

.withdraw .box .right .block .c .formGroup .bankList .item[data-v-51c5dcd0][data-v-3d893316],
.withdraw .box .right .block .c .scanCode .bankList .item[data-v-51c5dcd0][data-v-3d893316],
.withdrawUSDT .box .right .block .c .formGroup .bankList .item[data-v-51c5dcd0][data-v-3d893316],
.withdrawUSDT .box .right .block .c .scanCode .bankList .item[data-v-51c5dcd0][data-v-3d893316] {
  height: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/withdraw.vue